// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"b71a0d64","453":"9e31b4cd","777":"ef8630b6"}[chunkId] + ".chunk.js";
};